import { ReduceStore } from 'flux/utils';
import { Record, Map } from 'immutable';
import moment from 'moment';

import AppDispatcher from '../AppDispatcher';
import Constants from '../Constants';
import CurrentOrganizationIdStore from './CurrentOrganizationIdStore';

class SyncStatus extends Record({
  tableName: '',
  timestamp: moment(),
  status: '',
  numRowsUpdated: 0,
}) {

}

const processSyncStatus = (rawStatus) => (
  new SyncStatus({
    tableName: rawStatus.tablename,
    timestamp: moment.unix(rawStatus.updated_at),
    status: rawStatus.successful ? 'loaded' : 'failed',
    numRowsUpdated: rawStatus.records_updated,
  })
);

const processSyncStatuses = statuses => (
  new Map(statuses.map((status) => {
    const processedStatus = processSyncStatus(status);
    return [
      `${processedStatus.tableName}_${+processedStatus.timestamp}`,
      processedStatus,
    ];
  }))
);

class SyncStore extends ReduceStore {
  getInitialState() {
    return new Map();
  }

  reduce(state, action) {
    switch (action.actionType) {
      case Constants.RECEIVE_RAW_SYNCS:
        return this.newSyncStatusesForOrg(state, action);
      default:
        return state;
    }
  }

  getAllChrono() {
    return this.getState()
            .get(CurrentOrganizationIdStore.getState(), new Map())
            .toIndexedSeq();
  }

  getForFilter() {
    return this.getAllChrono();
  }

  newSyncStatusesForOrg(state, action) {
    const processedStatuses = processSyncStatuses(action.rawSyncs);
    const currentStatuses = state.get(action.organizationId, new Map());

    return state.set(
      action.organizationId,
      currentStatuses.merge(processedStatuses),
    );
  }
}

const instance = new SyncStore(AppDispatcher);
export default instance;
